import React from "react";
import { Link, useParams } from "react-router";
import { useSelector } from "react-redux";

const RoleBaseAccess = (OriginalComponent, extraProps) => {
    // const { permission } = useSelector((state) => state.leases);
    const NewComponent = (props) => {
        const { permission } = useSelector((state) => state.leases);
        const params = useParams();
        const parentPermission = permission?.permissions?.lease_revamp_application?.[extraProps.application]?.[extraProps.feature];
        const featurePermissionn = typeof extraProps.operationType === 'function' ? extraProps.operationType(params, props) : extraProps.operationType;
        if (featurePermissionn?.some(element => parentPermission?.includes(element))) {
            return <OriginalComponent {...props} />
        } else {
            return (
                <div style={{ width: '100vw', height: '100vh', position: 'fixed' }}>
                    <div style={{
                        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#000000',
                        textAlign: 'center', margin: '0 auto'
                    }}>
                        <br /><br />
                        Sorry, You do not have access to the Page.<br />
                        Please contact to Acumen for access<br />
                        <Link to="/leases"> Go Back</Link>
                    </div>
                </div>
            )
        }

    };
    return NewComponent;
};
export default RoleBaseAccess;

